var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280px",
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("팝업관리")]), _c('v-spacer')], 1), _c('v-data-table', {
    staticClass: "elevation-1 mt-4",
    attrs: {
      "headers": _vm.popupsHeaders,
      "items": _vm.popups,
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.createdAt.toDate()) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")]), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-delete ")])];
      }
    }])
  }), _c('v-pagination', {
    staticClass: "mt-4 mb-12",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-dialog', {
    attrs: {
      "max-width": "960px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', {
          attrs: {
            "bottom": "",
            "color": "accent",
            "dark": "",
            "fab": "",
            "fixed": "",
            "right": ""
          },
          on: {
            "click": _vm.create
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.popupDialog,
      callback: function ($$v) {
        _vm.popupDialog = $$v;
      },
      expression: "popupDialog"
    }
  }, [_vm.popupDialog ? _c('v-card', [_c('v-card-title', [_vm.editItem._id ? _c('span', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("팝업수정")]) : _c('span', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("팝업추가")])]), _c('v-card-text', [_c('v-container', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    staticClass: "mt-3",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "명칭",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "name", $$v);
      },
      expression: "editItem.name"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "순서",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.sequence,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "sequence", $$v);
      },
      expression: "editItem.sequence"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "URL",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.url,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "url", $$v);
      },
      expression: "editItem.url"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 pl-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "위치(x)",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.left,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "left", $$v);
      },
      expression: "editItem.left"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0 pr-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "위치(y)",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.top,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "top", $$v);
      },
      expression: "editItem.top"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 pl-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "크기(가로)",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.width,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "width", $$v);
      },
      expression: "editItem.width"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0 pr-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "크기(세로)",
      "persistent-placeholder": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.height,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "height", $$v);
      },
      expression: "editItem.height"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("전시여부")]), _c('v-spacer'), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.display.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.editItem.display, "enabled", $$v);
      },
      expression: "editItem.display.enabled"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("전시기간")]), _c('v-spacer'), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.display.period,
      callback: function ($$v) {
        _vm.$set(_vm.editItem.display, "period", $$v);
      },
      expression: "editItem.display.period"
    }
  })], 1)], 1), _vm.editItem.display.period ? _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 pl-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "startDateMenu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.editItem.display.startDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function ($event) {
        return _vm.$set(_vm.editItem.display, "startDate", $event);
      },
      "update:return-value": function ($event) {
        return _vm.$set(_vm.editItem.display, "startDate", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on;
        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "전시일자",
            "persistent-placeholder": "",
            "dense": "",
            "hide-details": "",
            "append-icon": "event",
            "readonly": ""
          },
          model: {
            value: _vm.editItem.display.startDate,
            callback: function ($$v) {
              _vm.$set(_vm.editItem.display, "startDate", $$v);
            },
            expression: "editItem.display.startDate"
          }
        }, on))];
      }
    }], null, false, 762798327)
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$refs.startDateMenu.save(_vm.editItem.display.startDate);
      }
    },
    model: {
      value: _vm.editItem.display.startDate,
      callback: function ($$v) {
        _vm.$set(_vm.editItem.display, "startDate", $$v);
      },
      expression: "editItem.display.startDate"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-0 pr-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "endDateMenu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.editItem.display.endDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function ($event) {
        return _vm.$set(_vm.editItem.display, "endDate", $event);
      },
      "update:return-value": function ($event) {
        return _vm.$set(_vm.editItem.display, "endDate", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on;
        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "전시일자",
            "persistent-placeholder": "",
            "dense": "",
            "hide-details": "",
            "append-icon": "event",
            "readonly": ""
          },
          model: {
            value: _vm.editItem.display.endDate,
            callback: function ($$v) {
              _vm.$set(_vm.editItem.display, "endDate", $$v);
            },
            expression: "editItem.display.endDate"
          }
        }, on))];
      }
    }], null, false, 2433731160)
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$refs.endDateMenu.save(_vm.editItem.display.endDate);
      }
    },
    model: {
      value: _vm.editItem.display.endDate,
      callback: function ($$v) {
        _vm.$set(_vm.editItem.display, "endDate", $$v);
      },
      expression: "editItem.display.endDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "pa-0"
  }, [_c('naver-smarteditor', {
    model: {
      value: _vm.editItem.content,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "content", $$v);
      },
      expression: "editItem.content"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }